// extracted by mini-css-extract-plugin
module.exports = {"main":"Slider_main__2CxOA","label":"Slider_label__2e9Wr","container":"Slider_container__3ZWIg","slider":"Slider_slider__2O89W","rangeValue":"Slider_rangeValue__L0PAk"};